import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ReportJournal = _resolveComponent("ReportJournal")!
  const _component_ReportIntercompanyElimination = _resolveComponent("ReportIntercompanyElimination")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.reportId == 1 || _ctx.reportId == 2)
              ? (_openBlock(), _createBlock(_component_ReportJournal, {
                  key: 0,
                  identifier: _ctx.identifier,
                  reportId: _ctx.reportId
                }, null, 8, ["identifier", "reportId"]))
              : _createCommentVNode("", true),
            (_ctx.reportId == 3)
              ? (_openBlock(), _createBlock(_component_ReportIntercompanyElimination, {
                  key: 1,
                  identifier: _ctx.identifier,
                  reportId: _ctx.reportId
                }, null, 8, ["identifier", "reportId"]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}